// Browser passkey ceremonies (task 387.11.6, ADR-063). The api sends WebAuthn options as JSON (Fido2NetLib) and takes
// the browser's response back as a JSON string; @simplewebauthn/browser does the base64url encoding both ways.

import {
  browserSupportsWebAuthn,
  startAuthentication,
  startRegistration,
  WebAuthnError,
} from '@simplewebauthn/browser';

export function passkeysSupported(): boolean {
  return browserSupportsWebAuthn();
}

/** Asks an existing passkey to sign the challenge. Resolves to the response for mfa verify `passkeyResponse`. */
export async function signWithPasskey(optionsJson: string): Promise<string> {
  const response = await startAuthentication({ optionsJSON: JSON.parse(optionsJson) });
  return JSON.stringify(response);
}

/** Creates a passkey for the options. Resolves to the response for passkey `complete`. */
export async function createPasskey(optionsJson: string): Promise<string> {
  const response = await startRegistration({ optionsJSON: JSON.parse(optionsJson) });
  return JSON.stringify(response);
}

/** A person-readable reason a ceremony did not finish. Cancelling is the common case and is not an error. */
export function passkeyErrorMessage(error: unknown): string {
  if (error instanceof WebAuthnError) {
    switch (error.code) {
      case 'ERROR_CEREMONY_ABORTED':
        return 'The passkey request was cancelled.';
      case 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED':
        return 'This device already holds a passkey for your account.';
      default:
        break;
    }
  }
  if (error instanceof Error && error.name === 'NotAllowedError') {
    return 'The passkey request was cancelled or timed out.';
  }
  return error instanceof Error ? error.message : 'The passkey could not be used.';
}
